import React, { useState, useEffect } from "react";
import { Button, Layout, Menu, Drawer } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import {
  DashboardOutlined,
  EditOutlined,
  FileTextOutlined,
  SearchOutlined,
  UserAddOutlined,
  UsergroupAddOutlined,
  MenuOutlined,
  LogoutOutlined,
  FormOutlined,
} from "@ant-design/icons";
import UserMenu from "./partials/UserMenu";
import LogoSrc from "../../assets/images/logo.png";
import smLogoSrc from "../../assets/images/logo-sm.png";
import Settings from "./partials/Settings";
import { logout } from "../../redux/auth/authSlice";
const { Header } = Layout;
function AuthLayout({ children }) {
  const navigate = useNavigate();
  const isDarkMode = useSelector((state) => state.app.isDarkMode);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const location = useLocation(); // Get current location
  const ROLES = {
    ADMIN: 1,
    OFFICE_MANAGER: 2,
    OFFICE_CLERK: 3,
    FIELD_CLERK: 4,
  };

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onClose = () => {
    setDrawerVisible(false);
  };
  // Get navigate function

  // Check user permission for specific routes
  useEffect(() => {
    // Check if the user is trying to access restricted routes
    const restrictedPaths = [
      // "/search",
      "/new-entry/personal",
      "/new-entry/business",
      "/new-entry/permit",
    ];

    const adminManagerPaths = [
      "/recommandation-form",
      "/recommendations/general",
      "/recommendations/business",
      "/recommendations/personal",
    ];

    if (
      restrictedPaths.includes(location.pathname) &&
      ![ROLES.ADMIN, ROLES.OFFICE_MANAGER, ROLES.FIELD_CLERK].includes(
        user?.permission
      )
    ) {
      navigate("/search");
    }

    if (
      adminManagerPaths.includes(location.pathname) &&
      ![ROLES.ADMIN, ROLES.OFFICE_MANAGER].includes(user?.permission)
    ) {
      navigate("/search");
    }
  }, [location.pathname, user?.permission, navigate]);

  const showRestrictedItems = [ROLES.ADMIN, ROLES.OFFICE_MANAGER].includes(
    user?.permission
  );

  const isFieldClerk = ROLES.FIELD_CLERK === user?.permission;
  const isOfficeClerk = ROLES.OFFICE_CLERK === user?.permission;

  const menuItems = [
    {
      label: "Search",
      key: "/search",
      icon: <SearchOutlined />,
    },
    ...(showRestrictedItems
      ? [
          {
            label: "Dashboard",
            key: "/dashboard",
            icon: <DashboardOutlined />,
          },
          {
            label: "Payment",
            key: "/payment-proof",
          },
          {
            label: "New Entry",
            key: "sub1",
            children: [
              {
                key: "/new-entry/personal",
                label: "Personal",
                icon: <UserAddOutlined />,
              },
              {
                key: "/new-entry/business",
                label: "Business",
                icon: <UsergroupAddOutlined />,
              },
              {
                key: "/new-entry/permit",
                label: "Permit",
                icon: <UsergroupAddOutlined />,
              },
            ],
          },
          {
            label: "Report",
            key: "/reports",
            icon: <FileTextOutlined />,
          },
          {
            label: "Document Base",
            key: "/recommandation-form",
            icon: <FormOutlined />,
          },
          {
            label: "Recommendation",
            key: "sub2",
            children: [
              {
                key: "sub3",
                label: "General",
                children: [
                  {
                    key: "/recommendations/general?type=general",
                    label: "General",
                    icon: <EditOutlined />,
                  },
                  {
                    key: "/recommendations/general?type=official",
                    label: "Official",
                    icon: <EditOutlined />,
                  },
                ],
              },
              {
                key: "/recommendations/personal",
                label: "Personal",
                icon: <UserAddOutlined />,
              },
              {
                key: "/recommendations/business",
                label: "Business",
                icon: <UsergroupAddOutlined />,
              },
            ],
          },
        ]
      : []),
    ...(isFieldClerk
      ? [
          {
            label: "New Entry",
            key: "sub1",
            children: [
              {
                key: "/new-entry/personal",
                label: "Personal",
                icon: <UserAddOutlined />,
              },
              {
                key: "/new-entry/business",
                label: "Business",
                icon: <UsergroupAddOutlined />,
              },
              {
                key: "/new-entry/permit",
                label: "Permit",
                icon: <UsergroupAddOutlined />,
              },
            ],
          },
        ]
      : []),
    ...(isOfficeClerk
      ? [
          {
            label: "Payment",
            key: "/payment-proof",
          },
        ]
      : []),
    {
      label: "Logout",
      key: "/logout",
      icon: <LogoutOutlined />,
    },
  ];

  return (
    <>
      <Layout className="min-h-screen">
        <Header
          className={classNames("shadow sticky top-0 z-[999]", {
            "bg-white text-black": !isDarkMode,
            //   'bg-gray-900 text-white': isDarkMode,
          })}
        >
          <div className="flex items-center max-w-7xl mx-auto w-full">
            <div className={classNames("h-16")}>
              <Link to="/dashboard" className="hidden sm:inline">
                <img src={LogoSrc} alt="logo" className="h-16 p-3" />
              </Link>
              <Link to="/dashboard" className="inline sm:hidden">
                <img src={smLogoSrc} alt="logo" className="h-16 p-3" />
              </Link>
            </div>
            <Menu
              mode="horizontal"
              theme={isDarkMode ? "dark" : "light"}
              defaultSelectedKeys={["2"]}
              items={menuItems}
              className={classNames("flex-1 min-w-0 flex justify-end")}
              onClick={({ key }) => {
                if (key == "/logout") {
                  return dispatch(logout());
                }
                navigate(key);
              }}
            />
          </div>
        </Header>
        <Layout>{children}</Layout>
        <Settings />
      </Layout>
    </>
  );
}

export default AuthLayout;
